import platformFetch from '../../platformFetch';

const controllerName = 'auth/platform';

const endpoints = {
  login: 'login',
  refresh: 'refresh',
  me: 'me',
};

export interface IPlatformAuthLogin {
  login: string;
  password: string;
}

export interface IPlatformAuthUser {
  login: string;
  scope: 'platform_admin';
}

export interface IPlatformAuthResponse {
  user: IPlatformAuthUser;
  accessToken: string;
  refreshToken: string;
}

export async function platformAuthLogin(data: IPlatformAuthLogin) {
  return platformFetch<IPlatformAuthResponse>({
    method: 'POST',
    path: `${controllerName}/${endpoints.login}`,
    data,
  });
}

export async function platformRefreshToken(refreshToken?: string) {
  const { data } = await platformFetch<IPlatformAuthResponse>({
    method: 'POST',
    path: `${controllerName}/${endpoints.refresh}`,
    data: {
      refreshToken,
    },
  });

  return data;
}

export async function getPlatformMe(accessToken: string) {
  const { data } = await platformFetch<IPlatformAuthUser>({
    method: 'GET',
    path: `${controllerName}/${endpoints.me}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return data;
}
